export class ClientModel {
    id: number;
    address: string | null;
    contactNumber: string | null;
    coordinates: string | null;
    costAccountCode: number;
    invoiceName: string | null;
    invoiceCode: string | number | null;
    invoicePrefix: string | null;
    name: string | null;
    paymentTerms: number;
    pointOfContact: string | null;
    postCode: number;
    isRequiredPod: boolean;
    stateId: number;
    stateName: string | null;
    stateAbbr: string | null;
    suburb: string | null;
    services: Record<string, any>;

    constructor () {
        this.id = 0;
        this.address = null;
        this.contactNumber = null;
        this.coordinates = null;
        this.costAccountCode = 0;
        this.invoiceName = null;
        this.invoiceCode = null;
        this.invoicePrefix = null;
        this.name = null;
        this.paymentTerms = 0;
        this.pointOfContact = null;
        this.postCode = 0;
        this.isRequiredPod = false;
        this.stateId = 0;
        this.stateName = null;
        this.stateAbbr = null;
        this.suburb = null;
        this.services = [];
    }

    public static fromJson (json: any): ClientModel {
        const client = new ClientModel;
        Object.assign(client, {
            id: json.id,
            address: json.address,
            contactNumber: json.contact_number,
            coordinates: json.coordinates,
            costAccountCode: json.cost_account_code,
            invoiceName: json.entity_name_invoice,
            invoiceCode: json.invoice_code,
            invoicePrefix: json.invoice_prefix,
            name: json.name,
            paymentTerms: json.payment_terms,
            pointOfContact: json.point_of_contact,
            postCode: json.post_code,
            isRequiredPod: json.required_pod,
            stateId: json.state?.id,
            stateName: json.state?.name,
            stateAbbr: json.state?.abbr,
            suburb: json.suburb,
            services: json.services
        });
        return client;
    }
}